import moment from 'moment';
import { isEqual, mapValues, omitBy, pickBy } from 'lodash';

import actions from '../actions';
import { ACCOUNT_CHANGE } from '../actionTypes';

const filterCachablePayments = (payments) => {
  const omitStatuses = ['sending', 'accepting', 'cancelling'];
  return pickBy(payments, payment => omitStatuses.indexOf(payment.status.toString()) === -1);
};

const handleLocalPayments = (storage, beforeState, afterState, action, store) => {
  // Load from cache.
  if (action.type === ACCOUNT_CHANGE) {
    const validAfter = moment().unix() - 600;
    const payments = omitBy(
      (storage.get('localPayments') || {})[action.address] || {},
      payment => payment.lastTouched && payment.lastTouched < validAfter,
    );
    store.dispatch(actions.paymentsLocallyLoaded(payments));
    return;
  }

  // Only check if the action is for payments, and we have an address.
  if (action.type.indexOf('PAYMENT_') !== -1 && afterState.account.address) {
    // Update cache if content has changed.
    if (!isEqual(beforeState.payments.localPayments, afterState.payments.localPayments)) {
      const { account: { address }, payments: { localPayments } } = afterState;
      storage.set('localPayments', {
        ...(storage.get('localPayments') || {}),
        [address]: filterCachablePayments(mapValues(localPayments, payment => ({
          ...payment,
          status: payment.status.toString(),
          lastTouched:
              action.payment && action.payment.transactionHash === payment.transactionHash
                ? moment().unix()
                : payment.lastTouched,
        }))),
      });
    }
  }
};

export default handleLocalPayments;



// WEBPACK FOOTER //
// ./src/middleware/localPaymentsPersistence.js